import onboardingGetters from "./getters.js";
import onboardingMutations from "./mutations.js";
import onboardingActions from "./actions.js";

export default {
  namespaced: true,
  state() {
    return {
      prospectsTimestamp: null,
      // True only while a prospects fetch is in flight, so a failed request
      // clears the loading state instead of leaving the board on a skeleton
      // forever. Same reasoning as recruitment's `jobsLoading`.
      prospectsLoading: false,
      // The company's prospects, newest-updated first. These are SUMMARY
      // records from the list endpoint — no jobPreferences and no notes. The
      // full record comes from `getProspect` and is not cached here, because
      // it carries a non-user's personal data (see the note in store/index.js
      // on why this module is excluded from localStorage).
      prospects: [],
      // Counts per stage for the whole company, independent of any stage
      // filter, so the board's column headers stay correct while filtered.
      stageCounts: {},
      // Server-side paging state from the last list response.
      page: 1,
      pageSize: 50,
      total: 0,
    };
  },
  getters: onboardingGetters,
  mutations: onboardingMutations,
  actions: onboardingActions,
};
